import React, { useCallback } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import {
  StudentFirstNameField,
  StudentLastNameField,
  StudentUsernameField,
  StudentSecretCodeField,
  StudentEmailAddressField,
  StudentGradeSelectField
} from '.';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconButtonContainer: {
      display: 'flex'
    },
    studentRow: {
      height: theme.typography.pxToRem(52),
      '& td': {
        verticalAlign: 'top'
      }
    }
  })
);

interface StudentTableRowProps {
  index: number;
  rowTouched?: boolean;
  usernames?: Array<string>;
  remove: (index: number) => void;
  onFocus: (index: number) => void;
}

export const StudentTableRow: React.FC<StudentTableRowProps> = ({
  index,
  remove,
  usernames,
  rowTouched,
  onFocus
}) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl]
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const handleDeleteClick = useCallback(() => {
    remove(index);
    handleClose();
  }, [remove, handleClose, index]);

  const handleOnFocus = (): void => {
    onFocus(index);
  };

  return (
    <tr className={classes.studentRow} onFocus={handleOnFocus}>
      <td>
        <StudentFirstNameField index={index} touched={rowTouched} />
      </td>
      <td>
        <StudentLastNameField index={index} touched={rowTouched} />
      </td>
      <td>
        <StudentUsernameField index={index} touched={rowTouched} usernames={usernames} />
      </td>
      <td>
        <StudentSecretCodeField index={index} touched={rowTouched} />
      </td>
      <td>
        <StudentEmailAddressField index={index} touched={rowTouched} />
      </td>
      <td>
        <StudentGradeSelectField index={index} touched={rowTouched} />
      </td>
      <td className={classes.iconButtonContainer}>
        <IconButton
          aria-controls="simple-menu"
          aria-haspopup="true"
          size="small"
          onClick={handleClick}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          <MenuItem onClick={handleDeleteClick}>Delete</MenuItem>
        </Menu>
      </td>
    </tr>
  );
};
